import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useAuth } from '../components/Providers/AuthProvider';
import { updateRelation } from '../redux/actions/userSpecificRelationsActions';
import { AppDispatch } from '../redux/store';
import { Prompt } from '../Types/prompt';
import { fetchPromptsUtil } from '../util/fetchPromptsUtil';
/**
 * Hook for managing prompt like functionality
 * @returns Object containing functions for managing likes
 */
export const useLikePrompt = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentUser } = useAuth();

  /**
   * Handles toggling a prompt like status
   * @param promptId - ID of the prompt to toggle like for
   * @param isLiked - Current like status
   * @returns Promise that resolves after like operation
   */
  const handleLike = useCallback(
    async (prompt: Prompt) => {
      if (!currentUser) return;

      await dispatch(
        updateRelation({
          promptId: prompt.id,
          liked: !prompt.liked,
        })
      );

      fetchPromptsUtil(dispatch, prompt.featured);
    },
    [dispatch, currentUser]
  );

  /**
   * Gets tooltip text for like button
   * @param isLiked - Whether the prompt is currently liked
   * @returns Tooltip text string
   */
  const getLikeTooltipText = useCallback((isLiked: boolean, isAIAppStore: boolean) => {
    return isLiked ? 'Remove Like' : `Like this ${isAIAppStore ? 'App' : 'Prompt'}`;
  }, []);

  return {
    handleLike,
    getLikeTooltipText,
  };
};
